import type {
  OfferByArticleNumberQuery,
  OfferByArticleNumberQueryVariables,
} from '#shared/types/goliath/goliath.types';

export default async (
  params: OfferByArticleNumberQueryVariables,
  progress = true
): Promise<OfferByArticleNumberQuery['offer'] | undefined> => {
  const { $goliathApi } = useNuxtApp();
  const data = await $goliathApi<
    OfferByArticleNumberQueryVariables,
    OfferByArticleNumberQuery,
    'offer'
  >('offer-by-article-number', params, 'offer', progress);
  return data?.product ? data : undefined;
};
